import { audienceConstants } from '../constants'

export const audienceLoad = () => {
  return {
    type: audienceConstants.AUDIENCE_LOAD
  }
}

export const audienceLoadSuccess = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_LOAD_SUCCESS,
    payload
  }
}

export const audienceLoadFailure = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_LOAD_FAILURE,
    payload
  }
}

export const audienceReset = () => {
  return {
    type: audienceConstants.AUDIENCE_RESET
  }
}

export const audienceSave = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_SAVE,
    payload
  }
}

export const audienceSaveSuccess = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_SAVE_SUCCESS,
    payload
  }
}

export const audienceSaveFailure = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_SAVE_FAILURE,
    payload
  }
}

export const audienceDelete = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_DELETE,
    payload
  }
}

export const audienceDeleteSuccess = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_DELETE_SUCCESS,
    payload
  }
}

export const audienceDeleteFailure = (payload) => {
  return {
    type: audienceConstants.AUDIENCE_DELETE_FAILURE,
    payload
  }
}
